import { render } from "./NotificationsComp.vue?vue&type=template&id=92a2b1f8"
import script from "./NotificationsComp.vue?vue&type=script&lang=js"
export * from "./NotificationsComp.vue?vue&type=script&lang=js"

import "./NotificationsComp.vue?vue&type=style&index=0&id=92a2b1f8&lang=css"

import exportComponent from "G:\\deploy\\cfan\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__